export const getAmplitudeLink = (deviceId: string | null): string | null => {
  return deviceId
    ? `https://app.amplitude.com/analytics/skelar/project/472284/search/${deviceId}`
    : null
}

export const getClarityUrl = (projectId: string | null): string | null => {
  return projectId
    ? `https://clarity.microsoft.com/projects/view/${projectId}/impressions?date=Last%203%20days`
    : null
}
